<template>
    <div class="select">
        <a href="" @click.prevent="showEditingSelector = true" v-show="!showEditingSelector">Edit</a>
        <select v-show="showEditingSelector" id="entry-status-select" class="plain-select" v-model="optionValue" @change="changeStatus()">
            <option value="" v-if="show_empty_option"></option>
            <option :selected="optionValue" v-for="(value, key) in options_list" :value="value.id" v-text="value.text"></option>
        </select>
    </div>
</template>

<script>
    export default {
        props: ['actionurl', 'current_id', 'machine_name', 'options_list', 'edit_by_default', 'show_empty_option'],
        data() {
            return {
              optionValue: this.current_id,
              showEditingSelector: (this.edit_by_default) ? true : false
            }
        },
        methods: {
            changeStatus: function() {
                let that = this;
                window.axios(
                    {
                        method: 'PUT',
                        url: this.actionurl,
                        data: {
                            [that.machine_name]: that.optionValue
                        }
                    }).then(function(response) {
                    let dataBack = response.data;
                    location.reload();
                });
            }
        }
    }

</script>
